import { ActionReducer, Action } from '@ngrx/store';
import { AppState } from '../../NGRX/core.state';

const EXCLUDED_ACTIONS = [
  '[Tracking] Track - Send parts of state to Tracking api',
  '@ngrx/store/update-reducers',
  '@ngrx/effects/init'
];

// Enable/disable debug logging globally
const DEBUG_ENABLED = true;

export function debug(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return function (state: AppState | undefined, action: Action) {
    const startTime = performance.now();
    
    try {
      const newState = reducer(state, action);
      
      if (DEBUG_ENABLED && !EXCLUDED_ACTIONS.includes(action.type)) {
        const duration = Math.round(performance.now() - startTime);
        
        console.group(`%c[NGRX Debug] ${action.type}`, 'color: #4CAF50; font-weight: bold;');
        console.log('%cAction:', 'color: #9E9E9E; font-weight: bold;', action);
        console.log('%cPrevious State:', 'color: #9E9E9E; font-weight: bold;', state);
        console.log('%cNext State:', 'color: #9E9E9E; font-weight: bold;', newState);
        console.log(`%cDuration: ${duration}ms`, `color: ${duration > 100 ? '#F44336' : '#4CAF50'}; font-weight: bold;`);
        console.groupEnd();
      }
      
      return newState;
    } catch (error) {
      console.error('[NGRX Debug] Error in reducer:', {
        action,
        error,
        state
      });
      throw error; // Re-throw to maintain normal error flow
    }
  };
}
